//@storybook-skip this is just the container for the printable report
import React from "react";
import { useLegacyReportData } from "../../hooks/useLegacyReportData";

const PrintableReport = React.lazy(() => import("./PrintableReport"));

const LegacyReportDownload = ({
	sessionId,
	onDone,
}: {
	sessionId: number;
	onDone: () => void;
}) => {
	const data = useLegacyReportData(sessionId);

	if (!data) {
		return null;
	}

	return (
		<React.Suspense fallback={null}>
			<PrintableReport data={data} onCancel={onDone} shouldDownload hidden />
		</React.Suspense>
	);
};

export default LegacyReportDownload;
